import React from "react";

function Contact() {
    return (
    <section className="page-section bg-light text-dark" id="contact">
        <div className="container px-4 px-lg-5 text-center">
            <h2 className="mb-4">CONTÁCTANOS HOY</h2>
            <div className="row gx-4 gx-lg-5 justify-content-center">
                <div className="col-lg-4 text-center mb-5 mb-lg-0">
                    <i className="fs-2 mb-3 text-muted"></i>
                    <div>luisadrian_castrejon@grupocavi.com.mx</div>
                    <div>saul_dominguez@grupocavi.com.mx</div>
                    <div>jaime_vela@grupocavi.com.mx</div>
                    <br></br>
                    <i className="fs-2 mb-3 text-muted"></i>
                    <div>433 880 0197</div>
                    <div>433 100 8201  /  433 100 1369</div>
                </div>
            </div>
        </div>
    </section>
    );
}

export default Contact;